import React from 'react';

import { calculateAge } from 'lib/helpers/utility';

import formatDate from 'components/shared/CustomizableBoard/widgets/helpers/formatDate';

const PatientDetails = ({ patient, appointmentDate, timezone }) => {
  return (
    <div className="flex items-center justify-between bg-[#003A4B] !py-3 !pl-6 !pr-4">
      <div className="grid">
        <p className="text-sm font-600 !text-white print:text-xl">{patient?.fullName}</p>
        <ul className="flex items-center gap-x-1">
          <li className="text-xs !text-white print:text-base">{formatDate(patient?.dob)}</li>
          <span className="text-xs !text-white print:text-base">•</span>
          <li className="text-xs !text-white print:text-base">
            {calculateAge({ dateOfBirth: patient?.dob })} years
          </li>
          {patient?.gender && (
            <>
              <span className="text-xs !text-white print:text-base">•</span>
              <li className="text-xs capitalize !text-white print:text-base">{patient?.gender}</li>
            </>
          )}
        </ul>
      </div>
      <div className="grid">
        {appointmentDate && (
          <p className="text-right text-sm font-600 !text-white print:text-xl">
            {formatDate(appointmentDate, timezone)}
          </p>
        )}
        <p className="text-right text-xs !text-white print:text-base">Chart ID: {patient?.id}</p>
      </div>
    </div>
  );
};

export default PatientDetails;
